// Generator-discovered file route for the production-file review/edit (spend
// gate). Component lives in `src/ad/routes/review.tsx` (Module K / K3). Reads the
// `creativeId` search param and hands it to the component as a prop (keeps the
// component decoupled from the router for testing).
import { createFileRoute } from '@tanstack/react-router';
import { ReviewRouteComponent } from '@/ad/routes/review';

function parseCreativeId(search: Record<string, unknown>): { creativeId?: number } {
  const raw = search.creativeId;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isInteger(n) && n > 0 ? { creativeId: n } : {};
}

export const Route = createFileRoute('/_authenticated/ad/review')({
  validateSearch: parseCreativeId,
  component: ReviewRoute,
});

function ReviewRoute(): React.ReactElement {
  const { creativeId } = Route.useSearch();
  return <ReviewRouteComponent creativeId={creativeId} />;
}
